import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';

const ProductEdit = ({ match }) => {
  const { id } = useParams(); // Use useParams to get the id from the URL
  const recordId = useParams(); // Assuming you're using React Router
  const history = useHistory();
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { isAuthenticated, companyId, userId, logout, token } = useAuth();
  
  useEffect(() => {
    // Check if the token is expired
    if (isAuthenticated && tokenIsExpired(token)) {
      // Token is expired, log out the user
      logout();
      return;
    }

  }, [isAuthenticated, companyId, token, logout]);
  const [formData, setFormData] = useState({
    name: '',
    gstRate: '',
    isSubmit: false
  });

  useEffect(() => {
    fetchData('ProductApi', `/ProductDetails/${id}`, token)
      .then((response) => {
        if (response.responseCode === '1111') {
          setFormData(response.response_data);
        }
      })
      .catch((error) => {
        console.error('Error fetching Product Details:', error);
      });
  }, [id]);

  const handleChange = (event) => {
    const { name, value, type } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? !prevData[name] : value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    // if (!formData.isSubmit) {
    //   return;
    // }

    setFormData(prevData => ({
      ...prevData,
      UpdatedBy: userId,
    }));

    // Validate form data here if needed

    updateData('ProductApi', `${id}`, formData, token)
      .then((response) => {
        console.log('Record updated successfully:', response.data);
        history.push('/ProductIndex');
      })
      .catch((error) => {
        console.error('Error updating record:', error);
      });
  };

  return (
    <div className="w-full max-w-sm container mt-2 mx-auto">
      <form onSubmit={handleSubmit}>
      <div className='w-full mb-2 flex items-center'>
          <h3 className='psheading flex-grow linkcolor' style={{ fontFamily: 'Times New Roman', fontSize: '29px' }}>Edit</h3>
          <Button
            variant="contained"
            style={{ marginLeft: '8px', backgroundColor: '#006400', color: 'white' }}
            onClick={handleSubmit}
          >
            Update
          </Button>

          <Button
            variant="contained"
            color="error"
            component={Link}
            to="/ProductIndex"
            className="linkcolor"
            style={{ marginLeft: '8px' }}
          >
            Cancel
          </Button>
        </div>
        {/* Display success and error messages if needed */}
        {errorMessage && <p className="text-red-500">{errorMessage}</p>}
        {successMessage && <p className="text-green-500">{successMessage}</p>}


        <div className="w-full mb-4 flex">
          <div className="w-1/2 mr-2">
            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="Name">
              Item Name
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              name="name"
              value={formData.name}
              onChange={handleChange}
              type="text"
              placeholder="Enter Brand Name"
            />
          </div>
          <div className="w-1/8 mr-2">
            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="rate">
              GST Rate
            </label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
              name="gstRate"
              value={formData.gstRate}
              onChange={handleChange}
              type="number"
              placeholder="Enter GST Rate"
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default ProductEdit;
